import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "section_our_solution" }
const _hoisted_2 = { class: "row" }
const _hoisted_3 = { class: "col-lg-12 col-md-12 col-sm-12" }
const _hoisted_4 = { class: "our_solution_category" }
const _hoisted_5 = { class: "solution_cards_box sol_card_top_3" }
const _hoisted_6 = { class: "solution_card mt-3" }
const _hoisted_7 = /*#__PURE__*/_createElementVNode("div", { class: "hover_color_bubble" }, null, -1)
const _hoisted_8 = { class: "solu_title" }
const _hoisted_9 = { key: 0 }
const _hoisted_10 = { key: 1 }
const _hoisted_11 = { class: "solu_description" }
const _hoisted_12 = { key: 0 }
const _hoisted_13 = { key: 1 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("div", _hoisted_6, [
              _hoisted_7,
              _createElementVNode("div", _hoisted_8, [
                (!$setup.readIsValidated && $setup.readIsCompleted)
                  ? (_openBlock(), _createElementBlock("h3", _hoisted_9, " Congratulations ! "))
                  : _createCommentVNode("", true),
                (!$setup.readIsValidated && !$setup.readIsCompleted)
                  ? (_openBlock(), _createElementBlock("h3", _hoisted_10, " Your account is not approved "))
                  : _createCommentVNode("", true)
              ]),
              _createElementVNode("div", _hoisted_11, [
                (!$setup.readIsValidated && $setup.readIsCompleted)
                  ? (_openBlock(), _createElementBlock("p", _hoisted_12, " You have joined our wait list successfully ! "))
                  : _createCommentVNode("", true),
                (!$setup.readIsValidated && !$setup.readIsCompleted)
                  ? (_openBlock(), _createElementBlock("p", _hoisted_13, " Please, complete your information to approve your account. "))
                  : _createCommentVNode("", true),
                _createElementVNode("button", {
                  type: "button",
                  class: "read_more_btn",
                  onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => ($setup.openSettingsModal && $setup.openSettingsModal(...args)))
                }, " Settings ")
              ])
            ])
          ])
        ])
      ])
    ])
  ]))
}